import { ReactComponent as CalloutIcon } from 'assets/icons/callout24.svg'
import { ReactComponent as FilledCircleIcon } from 'assets/icons/circle24.svg'
import { ReactComponent as CodeIcon } from 'assets/icons/code24.svg'
import { ReactComponent as ColumnsIcon } from 'assets/icons/columns24.svg'
import { ReactComponent as VoteListIcon } from 'assets/icons/common/voteList24.svg'
import { ReactComponent as EmbedIcon } from 'assets/icons/embedAlt24.svg'
import { ReactComponent as EmojiIcon } from 'assets/icons/emoji24.svg'
import { ReactComponent as FileIcon } from 'assets/icons/file24.svg'
import { ReactComponent as Header1Icon } from 'assets/icons/h124.svg'
import { ReactComponent as Header2Icon } from 'assets/icons/h224.svg'
import { ReactComponent as Header3Icon } from 'assets/icons/h324.svg'
import { ReactComponent as ImageIcon } from 'assets/icons/image24.svg'
import { ReactComponent as LineDividerIcon } from 'assets/icons/lineDivider.svg'
import { ReactComponent as LinkIcon } from 'assets/icons/link24.svg'
import { ReactComponent as DocumentLinkedIcon } from 'assets/icons/linkedDoc24.svg'
import { ReactComponent as BulletIcon } from 'assets/icons/listBulleted24.svg'
import { ReactComponent as ChecklistIcon } from 'assets/icons/listChecklist24.svg'
import { ReactComponent as NumberedIcon } from 'assets/icons/listNumbered24.svg'
import { ReactComponent as ToggleListIcon } from 'assets/icons/listToggle24.svg'
import { ReactComponent as AirtableIcon } from 'assets/icons/logos/airtable24.svg'
import { ReactComponent as FigmaIcon } from 'assets/icons/logos/figma24.svg'
import { ReactComponent as GiphyIcon } from 'assets/icons/logos/giphy24.svg'
import { ReactComponent as GithubIcon } from 'assets/icons/logos/github24.svg'
import { ReactComponent as GoogleDocsIcon } from 'assets/icons/logos/googleDocs24.svg'
import { ReactComponent as GoogleFormIcon } from 'assets/icons/logos/googleForm24.svg'
import { ReactComponent as GoogleMapsIcon } from 'assets/icons/logos/googleMaps24.svg'
import { ReactComponent as GoogleSheetsIcon } from 'assets/icons/logos/googleSheets24.svg'
import { ReactComponent as GoogleSlidesIcon } from 'assets/icons/logos/googleSlides24.svg'
import { ReactComponent as JiraIcon } from 'assets/icons/logos/jira.svg'
import { ReactComponent as LoomIcon } from 'assets/icons/logos/loom24.svg'
import { ReactComponent as MermaidIcon } from 'assets/icons/logos/mermaid24.svg'
import { ReactComponent as MiroIcon } from 'assets/icons/logos/miro24.svg'
import { ReactComponent as TwitterIcon } from 'assets/icons/logos/twitter24.svg'
import { ReactComponent as UnsplashIcon } from 'assets/icons/logos/unsplash24.svg'
import { ReactComponent as VimeoIcon } from 'assets/icons/logos/vimeo24.svg'
import { ReactComponent as YoutubeIcon } from 'assets/icons/logos/youtube24.svg'
import { ReactComponent as MentionIcon } from 'assets/icons/mention24alt.svg'
import { ReactComponent as QuoteIcon } from 'assets/icons/quote24.svg'
import { ReactComponent as TableIcon } from 'assets/icons/table24.svg'
import { ReactComponent as TableOfContents } from 'assets/icons/tableOfContents24.svg'
import { ReactComponent as TitleIcon } from 'assets/icons/title24.svg'
import { KeyboardShortcutTagProps } from 'common/KeyboardShortcutTag/KeyboardShortcutTag'
import { ColumnsPrompt } from 'common/Prose/Prompts/ColumnsPrompt/ColumnsPrompt'
import { LinkPrompt } from 'common/Prose/Prompts/LinkPrompt/LinkPrompt'
import { createPrompt } from 'common/Prose/Prompts/Prompt/Prompt'
import { DEFAULT_CALLOUT_COLOR, DEFAULT_QUOTE_COLOR } from 'common/Prose/constants/colorOptions'
import { toggleStateStore } from 'common/Prose/nodeViews/ToggleList/store'
import { isMarkActive } from 'common/Prose/utils/isMarkActive'
import { markAttributesForHref } from 'common/Prose/utils/link'
import { createTableNode } from 'components/DocRightRail/screens/InsertMenu/utils/insertTable'
import { pick } from 'lodash'
import { nodes } from 'prose-core'
import { ExtractStrongNodeSpecAttributes } from 'prose-core'
import {
  Airtable,
  Canva,
  Clickup,
  Figma,
  Giphy,
  Github,
  GoogleDocs,
  GoogleForms,
  GoogleMaps,
  GoogleSheets,
  GoogleSlides,
  Integration,
  Jira,
  Loom,
  Mermaid,
  Miro,
  Twitter,
  Unsplash,
  Vimeo,
  Youtube,
} from 'proseShared/IntegrationsIcons'
import { openEmojiPrompt } from 'proseShared/prompts/EmojiPrompt'
import { openMediaUploadPrompt } from 'proseShared/prompts/MediaUploadPrompt/MediaUploadPrompt'
import { openMentionPrompt } from 'proseShared/prompts/MentionPrompt/MentionPrompt'
import { openTableSizePrompt } from 'proseShared/prompts/TableSizePrompt/TableSizePrompt'
import { toggleMark } from 'prosemirror-commands'
import { Fragment, Node as ProseNode, Schema } from 'prosemirror-model'
import { EditorState, TextSelection, Transaction } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'
import { ReactNode } from 'react'
import store from 'redux/store'
import { ArticleFlat, ArticleMeta } from 'types'
import { ourUuid } from 'utils'
import Styles from './SlashMenuItems.module.scss'
import { openInsertEmbedPromptAndReturnNode } from './prompts/EmbedPrompt/EmbedPrompt'
import { findClosestCodeBlock } from './utils/findClosestCodeBlock'
import { IStackManager } from 'almanac-ui/Modal/Types'
import { ImageMenuSelectedImage } from 'components/ImageMenu/ImageMenuModal/ImageMenuContext'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { processSelectedImages } from 'components/ImageMenu/utils'
import { ACCEPTED_IMAGE_MIME_TYPES_NO_SVG } from 'screens/Finder/components/views/GalleryView/constants'

export interface SlashMenuItem {
  icon: ReactNode
  label: string
  markdown?: string
  keymap?: KeyboardShortcutTagProps
  internalOnly?: boolean
  enable: (state: EditorState) => boolean
  create: (
    view: EditorView,
    position: { top: number; left: number },
    anchor: number,
    length: number,
  ) => Promise<ProseNode | Fragment | void> | void
  postInsert?: (insertionPos: number, tr: Transaction) => void
}

export interface SlashMenuItemsGroup {
  title: string
  hideTitle?: true
  elements: SlashMenuItem[]
}

const toggleColoredMark = (view: EditorView, color: string, pos: number, length: number) => {
  const tr = view.state.tr

  tr.delete(pos - 1, pos + length)
  view.dispatch(tr)

  toggleMark(view.state.schema.marks.colored, { color })(view.state, view.dispatch)

  view.focus()
}

const insertMermaid = async (view: EditorView, position: { top: number; left: number }, integration?: Integration) => {
  return view.state.schema.nodes.mermaid_embed.createAndFill({}) as ProseNode
}

export interface SlashMenuItemsOptions {
  article: ArticleMeta
  tableMaxSize: number
  featureFlags: string[]
  stackManager: IStackManager
}

const textStyleGroup = (_: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const elements: SlashMenuItem[] = [
    {
      icon: <TitleIcon />,
      label: 'Title',
      enable: (state) => !!state.schema.nodes.heading,
      markdown: '# ',
      create: async (view) => {
        return view.state.schema.nodes.heading.createAndFill({ level: 1 }) as ProseNode
      },
    },
    {
      icon: <Header1Icon />,
      label: 'Heading 1',
      markdown: '## ',
      keymap: { keys: '1', modifiers: ['Mod', 'Opt'] },
      enable: (state) => !!state.schema.nodes.heading,
      create: async (view) => {
        return view.state.schema.nodes.heading.createAndFill({ level: 2 }) as ProseNode
      },
    },
    {
      icon: <Header2Icon />,
      label: 'Heading 2',
      markdown: '### ',
      keymap: { keys: '2', modifiers: ['Mod', 'Opt'] },
      enable: (state) => !!state.schema.nodes.heading,
      create: async (view) => {
        return view.state.schema.nodes.heading.createAndFill({ level: 3 }) as ProseNode
      },
    },
    {
      icon: <Header3Icon />,
      label: 'Heading 3',
      markdown: '#### ',
      keymap: { keys: '3', modifiers: ['Mod', 'Opt'] },
      enable: (state) => !!state.schema.nodes.heading,
      create: async (view) => {
        return view.state.schema.nodes.heading.createAndFill({ level: 4 }) as ProseNode
      },
    },
  ]

  return {
    title: 'Text Style',
    elements,
  }
}

const listGroup = (_: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const elements: SlashMenuItem[] = [
    {
      icon: <NumberedIcon />,
      label: 'Numbered list',
      markdown: '1. ',
      keymap: { keys: '7', modifiers: ['Mod', 'Shift'] },
      enable: (state) => !!state.schema.nodes.ordered_list,
      create: async (view) => {
        return view.state.schema.nodes.ordered_list.createAndFill({}) as ProseNode
      },
    },
    {
      icon: <BulletIcon />,
      label: 'Bulleted list',
      markdown: '* ',
      keymap: { keys: '8', modifiers: ['Mod', 'Shift'] },
      enable: (state) => !!state.schema.nodes.unordered_list,
      create: async (view) => {
        return view.state.schema.nodes.unordered_list.createAndFill({}) as ProseNode
      },
    },
    {
      icon: <ChecklistIcon />,
      label: 'Checklist',
      markdown: '[] ',
      keymap: { keys: '9', modifiers: ['Mod', 'Shift'] },
      enable: (state) => !!state.schema.nodes.check_list,
      create: async (view) => {
        return view.state.schema.nodes.check_list.createAndFill({}) as ProseNode
      },
    },
    {
      icon: <ToggleListIcon />,
      label: 'Toggle',
      enable: (state) => !!state.schema.nodes.toggle_list,
      create: async (view) => {
        const blockId = ourUuid()
        const node = view.state.schema.nodes.toggle_list.createAndFill({ blockId }) as ProseNode
        toggleStateStore.setState(blockId, false)
        return node
      },
    },
    {
      icon: <VoteListIcon />,
      label: 'Vote list',
      enable: (state) => !!state.schema.nodes.vote_list,
      create: async (view) => {
        return view.state.schema.nodes.vote_list.createAndFill({}) as ProseNode
      },
    },
  ]

  return {
    title: 'List',
    elements,
  }
}

const stylingElementsGroup = ({ article, featureFlags, tableMaxSize }: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const elements: SlashMenuItem[] = [
    {
      icon: <TableIcon />,
      label: 'Table',
      enable: (state) => !!state.schema.nodes.table,
      create: async (view, position) => {
        const tableSize = await openTableSizePrompt(
          view,
          {
            top: position.top,
            left: position.left,
          },
          tableMaxSize,
        )

        return createTableNode(view, tableSize, featureFlags.includes('dense_table'))
      },
    },
    {
      icon: <MentionIcon />,
      label: 'Mention',
      markdown: '@',
      enable: (state) => {
        const unregistered = store.getState().unregisteredUser.user
        return !unregistered && !!state.schema.nodes.smartLink
      },
      create: (view, _, triggerPos, length) => {
        openMentionPrompt(view, triggerPos, length)
      },
    },
    {
      icon: <CodeIcon />,
      label: 'Code block',
      markdown: '```',
      enable: (state) => !!state.schema.nodes.code_block,
      create: async (view) => {
        const {
          selection: {
            $from: { pos },
          },
          tr: { doc },
        } = view.state

        let codeBlockAttrs: Partial<ExtractStrongNodeSpecAttributes<typeof nodes.code_block>> = { lineNumbers: false }
        const closestCodeBlockInfo = findClosestCodeBlock(doc, pos)
        if (closestCodeBlockInfo !== null) {
          const [, codeBlockNode] = closestCodeBlockInfo
          Object.assign(codeBlockAttrs, pick(codeBlockNode.attrs, ['mime', 'theme', 'lineNumbers']))
        }

        if (isMarkActive(view.state, view.state.schema.marks.code)) {
          const {
            tr,
            schema,
            selection: { $from },
          } = view.state
          tr.replaceRangeWith($from.before(), $from.after(), schema.nodes.code_block.createAndFill(codeBlockAttrs))
          view.dispatch(tr)
        } else {
          return view.state.schema.nodes.code_block.createAndFill(codeBlockAttrs) as ProseNode
        }
      },
    },
    {
      icon: <EmojiIcon />,
      label: 'Emoji',
      enable: (state) => true,
      create: async (view, position, anchor, length) => {
        const { native } = await openEmojiPrompt(view, { top: position.top, left: position.left }, false)

        const anchorRes = view.state.doc.resolve(anchor - 1)
        const headRes = view.state.doc.resolve(anchorRes.pos + length + 1)
        const selection = new TextSelection(anchorRes, headRes)
        const tx = view.state.tr.setSelection(selection)

        tx.replaceSelectionWith(view.state.schema.text(native))
        view.dispatch(tx)
      },
    },
    // TODO: Add ToC here
    {
      icon: <LineDividerIcon className={Styles.icon} />,
      label: 'Divider',
      markdown: '---',
      enable: (state) => !!state.schema.nodes.line_divider,
      create: async (view) => {
        return view.state.schema.nodes.line_divider.createAndFill({}) as ProseNode
      },
    },
    {
      icon: <ColumnsIcon />,
      label: 'Columns',
      enable: (state) => !!state.schema.nodes.column_group,
      create: async (view, pos, anchor, length) => {
        createPrompt({
          view,
          position: pos,
          prompt: (close) => <ColumnsPrompt close={close} view={view} />,
        })
        return view.state.schema.nodes.paragraph.create(null)
      },
    },
    {
      icon: <CalloutIcon />,
      label: 'Callout',
      enable: (state) => !!state.schema.nodes.box,
      create: async (view) => {
        return view.state.schema.nodes.box.createAndFill({ boxColor: DEFAULT_CALLOUT_COLOR }) as ProseNode
      },
    },
    {
      icon: <QuoteIcon />,
      label: 'Quote',
      markdown: '> ',
      enable: (state) => !!state.schema.nodes.box,
      create: async (view) => {
        return view.state.schema.nodes.box.createAndFill({ quoteColor: DEFAULT_QUOTE_COLOR }) as ProseNode
      },
    },
    {
      icon: <LinkIcon />,
      label: 'Link',
      enable: (state) => true,
      create: (view, pos, anchor, length) => {
        const schema: Schema = view.state.schema
        const {
          selection: { from, to },
        } = view.state
        return new Promise((resolve, reject) => {
          createPrompt({
            view,
            refElement: view.domAtPos(view.state.selection.head).node as HTMLElement,
            left: pos.left,
            mobileEnabled: true,
            prompt: (close) => (
              <LinkPrompt
                article={article as ArticleFlat}
                close={close}
                initialText={view.state.doc.textBetween(from, to)}
                callback={({ link, text }) => {
                  if (!link) {
                    resolve()
                    return
                  }
                  text = text === '' ? link : text
                  resolve(schema.text(text, [schema.marks.link.create(markAttributesForHref(link))]))
                }}
              />
            ),
          })
        })
      },
    },
    {
      icon: (
        <MermaidIcon style={{ width: 20, height: 20, fill: '#1e1d1b', backgroundColor: '#f3f2f4', borderRadius: 4 }} />
      ),
      label: 'Mermaid.js',
      enable: (state) => !!state.schema.nodes.mermaid_embed,
      create: async (view, position) => {
        return insertMermaid(view, position, Mermaid)
      },
    },
  ]

  return {
    title: 'Styling Elements',
    elements,
  }
}

const mediaGroup = ({ stackManager, featureFlags }: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const elements: SlashMenuItem[] = [
    {
      icon: <ImageIcon />,
      label: 'Image',
      enable: (state: EditorState) => !!state.schema.nodes.image,
      create: async (view: EditorView) => {
        if (featureFlags.includes('new_image_menu')) {
          let resolveRef: Function

          const closePromise = new Promise<ImageMenuSelectedImage[]>((resolve) => {
            resolveRef = resolve
          })

          stackManager.openModal(ImageMenuModal, {
            hiddenProviders: ['stockVideo'],
            accept: ACCEPTED_IMAGE_MIME_TYPES_NO_SVG,
            onUse: async (images: ImageMenuSelectedImage[]) => {
              const processedImages = await processSelectedImages(images, { showProcessingToast: true })
              await resolveRef(processedImages)
            },
            maxCount: Infinity,
          })

          const images = await closePromise
          const imageNodes = images.map(
            ({ url }: { url: string }) => view.state.schema.nodes.image.createAndFill({ src: url }) as ProseNode,
          )
          stackManager.closeModal()
          return Fragment.fromArray(imageNodes)
        } else {
          const images = await openMediaUploadPrompt({
            view,
            stackManager,
          })
          const imageNodes = images.map(
            ({ url }: { url: string }) => view.state.schema.nodes.image.createAndFill({ src: url }) as ProseNode,
          )
          return Fragment.fromArray(imageNodes)
        }
      },
    },
    {
      icon: <FileIcon />,
      label: 'Upload a file',
      enable: (state: EditorState) => !!state.schema.nodes.download,
      create: async (view: EditorView) => {
        return view.state.schema.nodes.download.createAndFill({}) as ProseNode
      },
    },
    {
      icon: <DocumentLinkedIcon />,
      label: 'Link to a doc',
      markdown: '@',
      enable: (state: EditorState) => {
        const unregistered = store.getState().unregisteredUser.user
        return !unregistered && !!state.schema.nodes.smartLink
      },
      create: (view: EditorView, _: any, triggerPos: number, length: number) => {
        openMentionPrompt(view, triggerPos, length)
      },
    },
    {
      icon: <UnsplashIcon />,
      label: 'Unsplash',
      enable: (state: EditorState) => {
        const unregistered = store.getState().unregisteredUser.user
        return !unregistered && !!state.schema.nodes.smartLink
      },
      create: async (view: EditorView) => {
        const images = await openMediaUploadPrompt({
          view,
          preselectedIntegration: Unsplash,
          stackManager,
        })
        const imageNodes = images.map(
          ({ url }: { url: string }) => view.state.schema.nodes.image.createAndFill({ src: url }) as ProseNode,
        )
        return Fragment.fromArray(imageNodes)
      },
    },
    {
      icon: <GiphyIcon />,
      label: 'Giphy',
      enable: (state: EditorState) => {
        const unregistered = store.getState().unregisteredUser.user
        return !unregistered && !!state.schema.nodes.smartLink
      },
      create: async (view: EditorView) => {
        const images = await openMediaUploadPrompt({
          view,
          preselectedIntegration: Giphy,
          stackManager,
        })
        const imageNodes = images.map(
          ({ url }: { url: string }) => view.state.schema.nodes.image.createAndFill({ src: url }) as ProseNode,
        )
        return Fragment.fromArray(imageNodes)
      },
    },
  ]

  return {
    title: 'Media',
    elements,
  }
}

const embedsGroup = ({ featureFlags }: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const elements: SlashMenuItem[] = [
    {
      icon: <EmbedIcon />,
      label: 'Embed',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position })
      },
    },
    {
      icon: <AirtableIcon />,
      label: 'Airtable',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Airtable })
      },
    },
    {
      icon: (
        <img
          src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1647993259/public/icons/Canva_icon_rzfvd9.png"
          alt="Canva icon"
        />
      ),
      label: 'Canva',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Canva })
      },
    },
    {
      icon: (
        <img
          height="20px"
          src="https://res.cloudinary.com/almanac/image/upload/f_auto,q_auto/v1647993487/public/icons/Clickup_icon_l0rjm4.png"
          alt="Clickup icon"
        />
      ),
      label: 'Clickup',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Clickup })
      },
    },
    {
      icon: <FigmaIcon />,
      label: 'Figma',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Figma })
      },
    },
    {
      icon: <GithubIcon />,
      label: 'Github',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Github })
      },
    },
    {
      icon: <GoogleDocsIcon />,
      label: 'Google Docs',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: GoogleDocs })
      },
    },
    {
      icon: <GoogleFormIcon />,
      label: 'Google Form',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: GoogleForms })
      },
    },
    {
      icon: <GoogleSheetsIcon />,
      label: 'Google Sheets',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: GoogleSheets })
      },
    },
    {
      icon: <GoogleSlidesIcon />,
      label: 'Google Slides',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: GoogleSlides })
      },
    },
    {
      icon: <GoogleMapsIcon />,
      label: 'Google Maps',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: GoogleMaps })
      },
    },
    {
      icon: <JiraIcon />,
      label: 'Jira',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Jira })
      },
    },
    {
      icon: <LoomIcon />,
      label: 'Loom',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Loom })
      },
    },
    {
      icon: <MiroIcon />,
      label: 'Miro',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Miro })
      },
    },
    {
      icon: <TableOfContents />,
      label: 'Table of contents',
      enable: (state) => {
        return featureFlags.includes('new_inline_format_bar') && state.schema.nodes.table_of_contents
      },
      create: async (view) => {
        return view.state.schema.nodes.table_of_contents.createAndFill({})
      },
    },
    {
      icon: <TwitterIcon />,
      label: 'Twitter',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Twitter })
      },
    },
    {
      icon: <VimeoIcon />,
      label: 'Vimeo',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Vimeo })
      },
    },
    {
      icon: <YoutubeIcon />,
      label: 'Youtube',
      enable: (state) => !!state.schema.nodes.iframe,
      create: async (view, position) => {
        return openInsertEmbedPromptAndReturnNode({ view, position, preselectedIntegration: Youtube })
      },
    },
  ]

  return {
    title: 'Embed',
    elements,
  }
}

const colorsGroup = (_: SlashMenuItemsOptions): SlashMenuItemsGroup => {
  const colors: Array<[string, string]> = [
    ['Default', '#13151A'],
    ['Gray', '#757C8A'],
    ['Red', '#DD4740'],
    ['Orange', '#ED7C2C'],
    ['Yellow', '#EDB62C'],
    ['Green', '#00A39E'],
    ['Blue', '#287FBD'],
    ['Purple', '#8754BA'],
    ['Pink', '#E65CAC'],
  ]

  return {
    title: 'Color',
    elements: colors.map(([color, hex]) => {
      return {
        icon: <FilledCircleIcon style={{ fill: hex }} />,
        label: color,
        enable: (state) => !!state.schema.marks.colored,
        create: (view, _, anchor, length) => {
          toggleColoredMark(view, hex, anchor, length)
        },
      }
    }),
  }
}

export const slashMenuItems = (options: SlashMenuItemsOptions): SlashMenuItemsGroup[] => {
  return [
    textStyleGroup(options),
    listGroup(options),
    stylingElementsGroup(options),
    mediaGroup(options),
    embedsGroup(options),
    colorsGroup(options),
  ]
}
